import { FC } from "react";
import { HOW_TO_USE_KEY, TERMS_KEY} from "../../../../../constants";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";
import { Tabs } from "src/components";
import { useTranslation } from "react-i18next";
import { MdOutlineDescription, MdOutlineHelpOutline } from "react-icons/md";

type Props = {
  usageInstructions: string;
  termsAndCondition: string;
  activeKey: string;
  onChange: (key: string) => void;
};

const GiftcardInstructionsWeb: FC<Props> = ({ usageInstructions, termsAndCondition, activeKey, onChange }) => {
  const { t } = useTranslation();
  const items = [
    {
      key: HOW_TO_USE_KEY,
      label: (
        <>
          <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
            <MdOutlineHelpOutline className="h-5 w-5" />
          </div>
          <span className="text-font-default">{t("UserHistory.giftcard.howToUse")}</span>
        </>
      ),
      children: <GiftcardHtml className="text-font-default flex flex-col gap-2 text-xs p-2" html={usageInstructions} />,
    },
    {
      key: TERMS_KEY,
      label: (
        <>
          <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
            <MdOutlineDescription className="h-5 w-5" />
          </div>
          <span className="text-font-default">{t("UserHistory.giftcard.termsAndConditions")}</span>
        </>
      ),
      children: <GiftcardHtml className="text-font-default flex flex-col gap-2 text-xs p-2" html={termsAndCondition} />,
    },
  ];

  return (
    <div className="bg-background-default rounded-xs flex w-full flex-col shadow-sm">
      <Tabs
        items={items}
        activeKey={activeKey}
        onChange={onChange}
        classNames={{
          item: "gap-3! p-4! font-semibold!",
          content: "w-full px-3 py-2 text-start",
          header:"px-5!"
        }}
      />
    </div>
  );
};

export default GiftcardInstructionsWeb;
